// extracted by mini-css-extract-plugin
module.exports = {"container":"safe-index_container_3m5a4","chartBox":"safe-index_chartBox_2vok5"};